import { httpClient } from "@genai/http-client";

export const openPdfAtPage = async (
  url: string,
  page: number,
  headers: { Authorization: string },
) => {
  try {
    const response = await httpClient(url, { headers });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const blob = await response.blob();
    const pdfBlob = new Blob([blob], { type: "application/pdf" });
    const blobUrl = URL.createObjectURL(pdfBlob);
    const pdfUrl = `${blobUrl}#page=${page}`;
    window.open(pdfUrl, "_blank");
  } catch (error) {
    console.error("Error opening PDF:", error);
  }
};
